import { gql } from "@apollo/client";
import GraphQlService from "./graphql";

class customReportGraphql extends GraphQlService {
  async createCustomReportTemplate(data) {
    return this.client
      .mutate({
        mutation: gql`
        mutation {
          createCustomReportTemplate(createCustomReportTemplateInput: {
            name: "${data.name}",
            description: "${data.description}",
            content: """${data.content}""",
            accountId : "${data.accountId}"
            screenType: "${data.screenType}"
            accessType: "${data.accessType}"
            public: ${data.public}
            active: ${data.active}
          }) {
            id
          }
        }
      `,
      })
      .then((res) => res.data.createCustomReportTemplate);
  }

  async getAllCustomReportTemplates() {
    return this.client
      .query({
        query: gql`
          query {
            getAllCustomReportTemplates {
              id
              name
              description
              content
              accountId
              screenType
              accessType
              public
              active
            }
          }
        `,
      })
      .then((res) => res.data.getAllCustomReportTemplates);
  }

  async getCustomReportTemplate(id) {
    return this.client
      .query({
        query: gql`
          query {
            getCustomReportTemplate(id: "${id}") {
              id
              name
              description
              content
              accountId
              screenType
              accessType
              public
              active
            }
          }
        `,
      })
      .then((res) => res.data.getCustomReportTemplate);
  }

  async updateCustomReportTemplate(data) {
    return this.client
      .mutate({
        mutation: gql`
        mutation {
          updateCustomReportTemplate(updateCustomReportTemplateInput: {
            id: "${data.id}",
            name: "${data.name}",
            description: "${data.description}",
            content: """${data.content}""",
            accountId : "${data.accountId}"
            screenType: "${data.screenType}"
            accessType: "${data.accessType}"
            public: ${data.public}
            active: ${data.active}
          }) {
            id
          }
        }
      `,
      })
      .then((res) => res.data.updateCustomReportTemplate);
  }

  async removeCustomReportTemplate(id) {
    return this.client
      .mutate({
        mutation: gql`
        mutation {
          removeCustomReportTemplate(id: "${id}")
        }
      `,
      })
      .then((res) => res.data.removeCustomReportTemplate);
  }

  async getCustomRolesByCurrentUserForCustomReport(accountId = null) {
    return this.client
      .query({
        query: gql`
          query {
            getCustomRolesByCurrentUserForCustomReport(
              accountId: ${accountId ? `"${accountId}"` : null}
            ) {
              id
              accountId
              organizationName
              nameENG
              nameSW
              count
            }
          }
        `,
      })
      .then((res) => res.data.getCustomRolesByCurrentUserForCustomReport);
  }

  async setCustomReportConfig(data) {
    return this.client
      .mutate({
        mutation: gql`
        mutation {
          setCustomReportConfig(setCustomReportConfigInput: {
            reportTemplateId: "${data.reportTemplateId}",
            allowAnonymousReports: ${data.allowAnonymousReports},
            customRoles: """${JSON.stringify(data.customRoles)}"""
            secretLevel: "${data.secretLevel}",
          }) 
        }
      `,
      })
      .then((res) => res.data.setCustomReportConfig);
  }

  async createCustomReportReport(data) {
    return this.client
      .mutate({
        mutation: gql`
        mutation {
          createCustomReportReport(createCustomReportReportInput: {
            content: """${JSON.stringify(data.content)}""",
             reportConfigId:"${data.reportConfigId}",
             userId:"""${JSON.stringify(data.userId)}""",
             template: """${JSON.stringify(data.template)}"""
             anonymousData: ${
               data.anonymousData
                 ? `"""${JSON.stringify(data.anonymousData)}"""`
                 : null
             }
          }) {
            id
          }
        }
      `,
      })
      .then((res) => res.data.createCustomReportReport);
  }

  async getTempCustomReports(id) {
    return this.client
      .query({
        query: gql`
          query {
            getTempCustomReports(id: "${id}") {
              text
            }
          }
        `,
      })
      .then((res) => res.data.getTempCustomReports);
  }

  async removeTempCustomReports(id) {
    return this.client
      .mutate({
        mutation: gql` 
        mutation {
          removeTempCustomReports(id: "${id}"){
           
           text
           
          }
    }`,
      })
      .then((res) => res.data.removeTempCustomReports);
  }

  async findAllUsersByCustomRolesId(customRolesId) {
    return this.client
      .query({
        query: gql`
          query {
            findAllUsersByCustomRolesId(customRolesId: "${customRolesId}") {
              id
              accountId
              userId
              organizationId
              organizationName
              name
              type
              isAnonymous
              profilePictureName
              about
              birthday
              gender
              createdAt
              updatedAt
              createdBy
              updatedBy
              version
              email
              isOnline
              allowEmailNotification
              profileVideoName
              isSecretIdentity
              color
              customRoles {
                id
                nameENG
                nameSW
                masterRolesId
              }
            }
          }
        `,
      })
      .then((res) => res.data.findAllUsersByCustomRolesId);
  }

  async getCustomReportConfigsByCurrentUser() {
    return this.client
      .query({
        query: gql`
          query {
            getCustomReportConfigsByCurrentUser {
              id
              accountId
              reportTemplateId
              allowAnonymousReports
              active
              createdAt
              updatedAt
              createdBy
              updatedBy
              version
              reportTemplate {
                id
                name
                description
                content
                screenType
                accessType
              }
              customReportReports {
                id
              }
              account {
                name
              }
              customRoles {
                id
                nameSW
                nameENG
              }
            }
          }
        `,
      })
      .then((res) => res.data.getCustomReportConfigsByCurrentUser);
  }

  async getCustomReportConfigById(id) {
    return this.client
      .query({
        query: gql`
        query {
          getCustomReportConfig(id: "${id}") {
 
          id
          accountId
          reportTemplateId
          allowAnonymousReports
          active
          reportTemplate{
            content
            name
            screenType
            accessType
          }
      }}
      `,
      })
      .then((res) => res.data.getCustomReportConfig);
  }

  async updateCustomReportRoles(data) {
    return this.client
      .mutate({
        mutation: gql`
        mutation {
          updateCustomReportRoles(updateCustomReportRolesInput: {
            customRoleIds: """${JSON.stringify(data.customRoleIds)}""",
            reportConfigId: "${data.reportConfigId}"
          }) 
        }
      `,
      })
      .then((res) => res.data.updateCustomReportRoles);
  }

  async getCombinedReportResultsByTemplateId(data) {
    return this.client
      .query({
        query: gql`
          query {
            getCombinedReportResultsByTemplateId(
              getReportStatisticsInput: {
                dtStart:"${data.dtStart}"
                dtEnd:"${data.dtEnd}"
                templateId: "${data.templateId}"
                deepFilterData: ${
                  data.deepFilterData.length > 0
                    ? `"""${JSON.stringify(data.deepFilterData)}"""`
                    : null
                }
                userId : ${
                  data.userId.length > 0
                    ? `"""${JSON.stringify(data.userId)}"""`
                    : null
                }
                resultId: ${
                  data.resultId.length > 0
                    ? `"""${JSON.stringify(data.resultId)}"""`
                    : null
                }
                filters: ${
                  data.filters.length > 0
                    ? `"""${JSON.stringify(data.filters)}"""`
                    : null
                }
              }
            ) {
              getAllReportResultsByTemplateId {
                amountOfReports
                isShowStudentList
                resultIds
                questions {
                  questionName
                  questionType
                  unansweredCount
                  unansweredUserId
                  unansweredResultIds
                  unansweredPercentage
                  options {
                    name
                    value
                    count
                    studentIds
                    resultIds
                    surveyQuestionName
                    __typename
                  }
                  __typename
                }
                __typename
              }
              getRecursionChartsDataReportQuestions {
                startDate
                endDate
                label
                type
                data {
                  questionName
                  questionType
                  unansweredCount
                  unansweredPercentage
                  unansweredUserId
                  options {
                    name
                    value
                    count
                    studentIds
                    surveyQuestionName
                    __typename
                  }
                  __typename
                }
              }
            }
          }
        `,
      })
      .then((res) => res.data.getCombinedReportResultsByTemplateId);
  }

  async getStatisticsUsersAndResultsByTemplateId(data) {
    return this.client
      .query({
        query: gql`
          {
            getStatisticsUsersAndResultsByTemplateId(
              getStatisticsUsersAndResultsByTemplateIdInput: {
                dtStart: "${data.dtStart}"
                dtEnd: "${data.dtEnd}"
                templateId: "${data.templateId}"
                userId: ${
                  data.userId.length > 0
                    ? `"""${JSON.stringify(data.userId)}"""`
                    : null
                }
                resultId: ${
                  data.resultId.length > 0
                    ? `"""${JSON.stringify(data.resultId)}"""`
                    : null
                }
                filters: ${
                  data.filters.length > 0
                    ? `"""${JSON.stringify(data.filters)}"""`
                    : null
                }
              }
            ) {
              users {
                  id
                  email
                  status
                  createdAt
                  resetPasswordToken
                  accountPeople {
                    id
                    accountId
                    organizationName
                    type
                    isOnline
                    about
                    gender
                    email
                    profilePictureName
                    name
                    accountPersonAttributes {
                      id
                      accountId
                      name
                      value
                      __typename
                    }
                    __typename
                  }
                  __typename
                }
                reports {
                  id
                  accountId
                  reportConfigId
                  userId
                  anonymousData
                  content
                  createdAt
                  createdBy
                  createdByUser{
                    id
                    accountPeople {
                      id
                      accountId
                      name
                    }
                  }
                  user {
                    id
                    email
                    status
                    createdAt
                    resetPasswordToken
                    accountPeople {
                      id
                      accountId
                      organizationName
                      type
                      isOnline
                      about
                      gender
                      email
                      profilePictureName
                      name
                      accountPersonAttributes {
                        id
                        accountId
                        name
                        value
                        __typename
                      }
                      __typename
                    }
                  }
                  reportConfig {
                    reportTemplate {
                      id
                      name
                      accountId
                      description
                      screenType
                      accessType
                      public
                      active
                      __typename
                    }
                    account {
                      name
                      __typename
                    }
                    __typename
                  }
                  __typename
                }
              }
            }
          `,
      })
      .then((res) => res.data.getStatisticsUsersAndResultsByTemplateId);
  }
}

const customReportGraphqlInstance = new customReportGraphql();
export default customReportGraphqlInstance;
